/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDiversity3Icon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-diversity-3"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M0.68 19.82L0.68 16.82Q0.68 15.85 1.36 15.18Q2.05 14.5 3 14.5L6.28 14.5Q6.65 14.5 6.99 14.68Q7.33 14.85 7.55 15.2Q8.32 16.3 9.49 16.9Q10.65 17.5 12 17.5Q13.35 17.5 14.53 16.9Q15.7 16.3 16.48 15.2Q16.7 14.85 17.04 14.68Q17.38 14.5 17.73 14.5L21 14.5Q21.98 14.5 22.65 15.18Q23.32 15.85 23.32 16.82L23.32 19.82Q23.32 20.38 22.94 20.76Q22.55 21.15 22 21.15L17 21.15Q16.45 21.15 16.06 20.76Q15.68 20.38 15.68 19.82L15.68 19.25Q14.82 19.68 13.9 19.91Q12.97 20.15 12 20.15Q11.05 20.15 10.13 19.91Q9.2 19.68 8.32 19.25L8.32 19.82Q8.32 20.38 7.94 20.76Q7.55 21.15 7 21.15L2 21.15Q1.45 21.15 1.06 20.76Q0.68 20.38 0.68 19.82ZM12 16Q11.18 16 10.44 15.6Q9.7 15.2 9.2 14.55Q8.7 13.82 7.95 13.43Q7.2 13.03 6.35 13Q7.15 12.2 8.84 11.69Q10.53 11.18 12 11.18Q13.5 11.18 15.19 11.69Q16.88 12.2 17.68 13Q16.8 13.03 16.06 13.43Q15.32 13.82 14.82 14.55Q14.35 15.22 13.6 15.61Q12.85 16 12 16ZM4 12.5Q2.63 12.5 1.65 11.53Q0.68 10.55 0.68 9.18Q0.68 7.78 1.65 6.81Q2.63 5.85 4 5.85Q5.4 5.85 6.36 6.81Q7.33 7.78 7.33 9.18Q7.33 10.55 6.36 11.53Q5.4 12.5 4 12.5ZM20 12.5Q18.63 12.5 17.65 11.53Q16.68 10.55 16.68 9.18Q16.68 7.78 17.65 6.81Q18.63 5.85 20 5.85Q21.4 5.85 22.36 6.81Q23.32 7.78 23.32 9.18Q23.32 10.55 22.36 11.53Q21.4 12.5 20 12.5ZM12 9.18Q10.63 9.18 9.65 8.2Q8.68 7.22 8.68 5.85Q8.68 4.45 9.65 3.49Q10.63 2.52 12 2.52Q13.4 2.52 14.36 3.49Q15.32 4.45 15.32 5.85Q15.32 7.22 14.36 8.2Q13.4 9.18 12 9.18Z" fill={color} />
    </svg>
  );
}
